<template>
  <div class="trending-publishings">
    <div class="container">
      <h2 v-if="false" class="heading">TRENDING</h2>

      <div class="publishings">
        <div class="row" v-if="loading">
          <div
            class="col-md-4 publishing"
            v-for="(publishing, n) in 9"
            :key="n"
          >
            <ArticleCardSkeleton :index="n" />
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div
              class="col-md-4 publishing"
              v-for="(publishing, n) in displayPublishings"
              :key="n"
            >
              <publishing-card
                :publishing="publishing"
                :bookMarks="bookMarks"
                :follwedBloggers="follwedBloggers"
                :index="n"
                :show-ranking="false"
                @bookMarkBlog="bookMarkBlog"
                @followBlogger="followBlogger"
              />
            </div>
          </div>
          <div class="row pagination">
            <pagination
              v-if="totalPages > 1"
              :length="totalPages"
              @page-changed="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/other-pages/guides/Pagination";
import PublishingCard from "@/components/other-pages/libraryResources/PublishingCard";
import ArticleCardSkeleton from "@/components/other-pages/libraryResources/ArticleCardSkeleton";
export default {
  name: "TrendingPublishings",
  props: ["loading", "publishings", "bookMarks", "follwedBloggers"],
  data() {
    return {
      startInd: 0,
      perPage: 9
    };
  },
  components: {
    PublishingCard,
    ArticleCardSkeleton,
    Pagination
  },
  computed: {
    totalPages() {
      return this.publishings
        ? Math.ceil(this.publishings.length / this.perPage)
        : 0;
    },
    displayPublishings() {
      let endInd = this.startInd + this.perPage;
      let thisPublishings = this.publishings.slice(this.startInd, endInd);
      this.$forceUpdate();
      return thisPublishings;
    }
  },
  methods: {
    bookMarkBlog(data) {
      this.$emit("bookMarkBlog", data);
    },
    followBlogger(data) {
      this.$emit("followBlogger", data);
    },
    changePage(page) {
      console.log(`Page is ${page}`);
      this.startInd = (page - 1) * this.perPage;
      console.log(`Start Index ${this.startInd}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.trending-publishings {
  padding-top: 33px;
  padding-bottom: 40px;
  .heading {
    margin-left: 12px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin-bottom: 4px;
  }
  .publishings {
    .publishing {
      display: flex;
      justify-content: stretch;
      align-items: stretch;
      margin-bottom: 20px;
    }
  }
}
</style>
